/**
 * @desc 查询报关合同明细
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.CustomsClearanceResponseDto>;
export function request(
  params: API.tms.customsClearance.exportDeclarationDetail.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/getCustomsClearanceDetails`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
